export class FilterDate {
    fromDate: Date = new Date();
    toDate: Date = new Date();
}

